import React from "react";
import SlidePanel from "../add_customer/SlidePanel";
import { X } from "lucide-react";

const SelectDocument = ({
  id_R,
  closeSelectDoc,
  isSelectDocumentOpen,
  docSelected,
  setDocSelected,
  ContinueSelectDoc,
}) => {
  return (
    <SlidePanel isOpen={isSelectDocumentOpen} onClose={closeSelectDoc}>
      <div className="relative flex flex-col h-full bg-white rounded-[12px]">
        {/* Close Button */}
        <div
          onClick={closeSelectDoc}
          className="absolute top-0 right-0 cursor-pointer h-[40px] w-[40px] bg-[#FF0000] rounded-tr-[10px] rounded-bl-[20px] flex items-center justify-center z-10"
        >
          <X color="#ffffff" />
        </div>

        <div className="w-full flex flex-col h-full mx-5">
          <div>
            <div className="mt-10 mx-auto items-center">
              <p className="text-[#000000] text-[20px] font-bold">
                Upload Document
              </p>

              <div className="text-[#000000] mt-5 text-[15px] font-[300]">
                <p>Choose which document you wish to upload for the member.</p>
              </div>
            </div>

            <div className="w-full mt-16 pr-5">
              <div className="flex w-full flex-col">
                <label
                  htmlFor="county"
                  className="mb-1 text-md font-normal text-[#000]"
                >
                  Select document
                </label>

                <select
                  name="Idtype"
                  id="Idtype"
                  value={docSelected}
                  onChange={(e) => setDocSelected(e.target.value)}
                  className="w-[95%] bg-[#EAEAEA] h-10 px-4 border-[1px] rounded-[4px] border-[#EAEAEA]"
                >
                  <option value="National_ID">National ID</option>
                  <option value="Selfie">Selfie</option>
                </select>
              </div>
            </div>
          </div>

          <div className="flex w-[95%] items-end justify-end h-[60%] mr-5">
            <button
              onClick={ContinueSelectDoc}
              data-modal-toggle={id_R}
              type="button"
              className="text-white hover:bg-[#074073] focus:outline-none font-medium w-full rounded text-sm px-8 py-2.5 text-center bg-[#074073]"
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </SlidePanel>
  );
};

export default SelectDocument;
